import Modal from "./Modal";
import ModalContacts from "./ModalContacts";

export default class ModalForms {
  constructor() {
    this.successForm = null;
    this.errorForm = null;
    this.init();
  }

  /** @private */
  init = () => {
    this.createSuccessForm();
    this.createErrorForm();
    this.createMessageForm();
    this.createContactsForm();
  }

  /** @private */
  createSuccessForm = () => {
    this.successForm = new Modal();

    const content =
        `
          <h4>Заявка успешно отправлена</h4>
          <div>
            <p>Наш менеджер свяжется с вами в ближайшее время.</p>
          </div>
        `;
    this.successForm.setContent(content);
  }

  /** @private */
  createErrorForm = () => {
    this.errorForm = new Modal();

    const content =
        `
          <h4>Произошла ошибка отправки</h4>
          <div>
            <p>Что-то пошло не так, Ваша заявка не была отправлена. Попробуйте еще раз или свяжитесь с нами по номеру телефона:</p>
            <a href="tel:+375291898322">+375 (29) 189-83-22</a>
            <a href="tel:+79065178969">+7 (906) 517-89-69</a>
          </div>
        `;
    this.errorForm.setContent(content);
  }

  /** @private */
  createMessageForm = () => {
    this.messageForm = new Modal();
  }

  /** @private */
  createContactsForm = () => {
    this.contactsForm = new ModalContacts('modal-contacts');
  }

  showContactsForm = (params = {}) => {
    this.contactsForm.setParams(params);
    this.contactsForm.show();
  }

  showMessage = (message = '', title = '') => {
     let content = `<h4>${title}</h4>`;

     if (message) {
       content += message;
     }

    this.messageForm.setContent(content);
    this.messageForm.show();
  }

  showSuccess = () => {
    this.successForm.show();
  }

  showError = () => {
    this.errorForm.show();
  }

}